import type * as BasketUpdated from '@ori-events/basket-updated';
import {
  isRemoveShippingOfferItemErrorResponse,
  Name as ErrorEventName,
} from '@ori-events/remove-shipping-offer-item-failed';
import type { Data as ErrorData } from '@ori-events/remove-shipping-offer-item-failed';
import type { PositionData } from '@ori/analytics-data';
import { HttpMethod } from '@ori/checkout-utils';
import { TENANT_CONTEXT } from '@ori/fetching';
import type { DeleteShoppingSessionShippingJokerChoiceHeaders } from '@ori/global-api-client-react';
import { deleteShoppingSessionShippingJokerChoice } from '@ori/global-api-client-react';

import { mainLogger } from '../logger';
import { RequestUrl, type HandlerSettings } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';

const dispatchErrorEvent = (detail: ErrorData) => {
  const errorEvent = new CustomEvent<ErrorData>(ErrorEventName, {
    detail,
  });
  window.dispatchEvent(errorEvent);
};

export async function removeShippingOfferItemHandler(
  { detail: positionData }: CustomEvent<PositionData>,
  { client, sessionId, tenant }: HandlerSettings,
) {
  const headers: DeleteShoppingSessionShippingJokerChoiceHeaders = {
    [TENANT_CONTEXT]: tenant,
  };

  try {
    await deleteShoppingSessionShippingJokerChoice(client, sessionId, headers);
  } catch (error: unknown) {
    mainLogger.error(error as Error, {
      message: 'Error while removing shipping offer choice in remove-shipping-offer-item event.',
    });
    dispatchErrorEvent({
      isSuccess: false,
      localizedMessage: '',
      message: 'Removal of shipping offer choice via API call failed.',
    });

    return false;
  }

  const response = await fetch(RequestUrl.GetShoppingContext, getHttpRequestSettings(positionData, HttpMethod.Post));

  const data = convertToCamelCase<BasketUpdated.Data>((await response.json()) as object);

  if (isRemoveShippingOfferItemErrorResponse(data)) {
    dispatchErrorEvent(data);

    return false;
  }

  return data;
}
